import { render, staticRenderFns } from "./invitacion_tab.vue?vue&type=template&id=fc35e794&scoped=true"
import script from "./invitacion_tab.vue?vue&type=script&lang=js"
export * from "./invitacion_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc35e794",
  null
  
)

export default component.exports